module.exports = __webpack_public_path__ + "static/img/indexk.1417a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexk.png
// module id = goQ7
// module chunks = 1